import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/root';
import { setNotApplicables } from '../../../../../redux/slices/documentsSlice';

const NotApplicableFiles = () => {
  const { SelectedDocument, notApplicables } = useSelector((s: RootState) => s.documents);
  const [disabled, setDisabled] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setDisabled(Object.keys(SelectedDocument).length === 0);
  }, [SelectedDocument]);

  const onChange = e => {
    const _napp = { ...notApplicables, [SelectedDocument.pk]: e.target.checked };
    dispatch(setNotApplicables(_napp));
  };

  const checked = !!notApplicables[SelectedDocument.pk];

  return (
    <Row>
      <CheckboxLabel $disabled={disabled}>
        <Checkbox type="checkbox" onChange={onChange} disabled={disabled} checked={checked} />
        <span>Not Applicable</span>
      </CheckboxLabel>
    </Row>
  );
};

export default NotApplicableFiles;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const CheckboxLabel = styled.label<{ $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ $disabled }) => ($disabled ? 'var(--neutral-400)' : 'var(--neutral-700)')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

const Checkbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 1.5px solid var(--neutral-400);
  border-radius: 4px;
  background: var(--neutral-0);
  cursor: inherit;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:checked {
    background: var(--primary-600);
    border-color: var(--primary-600);
  }

  &:checked::after {
    content: '';
    width: 5px;
    height: 9px;
    border: solid var(--neutral-0);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translate(-1px, -1px);
  }

  &:disabled {
    background: var(--neutral-100);
    border-color: var(--neutral-300);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
